import React from "react";

const NotFoundMagnifier = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.75 24.375C48.75 29.7682 46.9984 34.7524 44.0331 38.7896C44.1831 38.9002 44.3266 39.0233 44.4624 39.1591L58.9017 53.5984C60.3661 55.0628 60.3661 57.4372 58.9017 58.9017C57.4372 60.3661 55.0628 60.3661 53.5984 58.9017L39.1591 44.4624C39.0233 44.3266 38.9002 44.1831 38.7896 44.0331L38.7928 44.0307C34.755 46.9975 29.7697 48.75 24.375 48.75C10.9131 48.75 0 37.8369 0 24.375C0 10.9131 10.9131 0 24.375 0C37.8369 0 48.75 10.9131 48.75 24.375ZM24.375 45C35.7659 45 45 35.7659 45 24.375C45 12.9841 35.7659 3.75 24.375 3.75C12.9841 3.75 3.75 12.9841 3.75 24.375C3.75 35.7659 12.9841 45 24.375 45ZM17.2863 15.3923C16.7633 14.8692 15.9153 14.8692 15.3923 15.3923C14.8692 15.9153 14.8692 16.7633 15.3923 17.2863L22.481 24.375L15.3923 31.4637C14.8692 31.9867 14.8692 32.8347 15.3923 33.3577C15.9153 33.8808 16.7633 33.8808 17.2863 33.3577L24.375 26.269L31.4637 33.3577C31.9867 33.8808 32.8347 33.8808 33.3577 33.3577C33.8808 32.8347 33.8808 31.9867 33.3577 31.4637L26.269 24.375L33.3577 17.2863C33.8808 16.7633 33.8808 15.9153 33.3577 15.3923C32.8347 14.8692 31.9867 14.8692 31.4637 15.3923L24.375 22.481L17.2863 15.3923Z"
      fill="#1366FF"
    />
  </svg>
);

export default NotFoundMagnifier;
